/* eslint-disable array-callback-return */
// @ts-nocheck
import React, { useContext, Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { ActaAuthContext } from "./pa_kit/auth";
import App from './app';
import RegistrationApp from './registration_app';
import { SubscriberAuthContext } from 'services/auth_subscriber';
import CheckRegistrationRoute from 'checkRegistrationRoute';


const AppRoutes = () => {

    const auth = useContext(ActaAuthContext);
    const subscriber_auth = useContext(SubscriberAuthContext);

    const theme = auth.theme;  

    const defaultTheme = {
        "--color-primary": theme.primary_color,
        "--color-secondary": theme.secondary_color,
        "--color-tertiary": theme.tertiary_color,
        "--color-quaternary": theme.quaternary_color,
    }    

    const applyTheme = (theme) => {
        Object.keys(theme).map((key) => {
            const value = theme[key];
            document.documentElement.style.setProperty(key, value);
        });
    };
    
    applyTheme(defaultTheme);

    const user = auth.user;

    const JobBoard = lazy(() => import('apps/job_board/components/job_board')); 
    const JobOfferPage = lazy(() => import('apps/job_offers/components/job_offer_page')); 
    const Registration = lazy(() => import('apps/registration/components/registration')); 
    const ApplicantRegistration = lazy(() => import('apps/applicants/components/applicant_registration')); 
    const CompanyRegistration = lazy(() => import('apps/companies/components/company_registration')); 
    
    const Profile = lazy(() => import('apps/profile/components/profile')); 
    const ProfileMain = lazy(() => import('apps/profile/components/profile_main'));
    const CurriculumVitae = lazy(() => import('apps/applicants/components/curriculum_vitae'));
    const BookmarkedOffers = lazy(() => import('apps/bookmarked_offers/components/bookmarked_offers_list'));
    const CompanyInfo = lazy(() => import('apps/companies/components/company_info'));
    const JobOffersList = lazy(() => import('apps/job_offers/components/job_offers_list'));
    const JobApplicationsList = lazy(() => import('apps/job_applications/components/job_applications_list'));
    const CreateJobOffer = lazy(() => import('apps/job_offers/components/create_job_offer'));
    const EditJobOffer = lazy(() => import('apps/job_offers/components/edit_job_offer'));
    const ActivitiesList = lazy(() => import('apps/activities/components/activities_list'));
    const ProfileSettings = lazy(() => import('apps/profile/components/profile_settings'));

    const Dashboard = lazy(() => import('admin/dashboard/dashboard'));
    const Main = lazy(() => import('admin/dashboard/main'));
    const AdminApplicantsList = lazy(() => import('admin/applicants/applicants_list'));
    const AdminCompaniesList = lazy(() => import('admin/companies/companies_list'));
    const AdminJobOffersList = lazy(() => import('admin/job_offers/job_offers_list'));
    const AdminJobApplicationsList = lazy(() => import('admin/job_applications/job_applications_list'));
    const AdminActivitiesList = lazy(() => import('admin/activities/activities_list'));


    if(auth.isLoading) return <div></div>;
    if(subscriber_auth.isLoading) return <div></div>;
    return <>
        <BrowserRouter>
            <Suspense fallback={<div></div>}>
                <Routes>
                    <Route path="/registration/" element={subscriber_auth.isCompany || subscriber_auth.isApplicant ? <Navigate to="/profile/" /> :  <RegistrationApp />}>
                        <Route index element={<Registration />} />
                        <Route path="applicant-registration/" element={<ApplicantRegistration />} />
                        <Route path="company-registration/" element={<CompanyRegistration />} />
                    </Route>                    
                    <Route 
                        path="/" 
                        element={
                            <CheckRegistrationRoute>
                                <App />
                            </CheckRegistrationRoute>
                        }
                    >
                        <Route index element={<JobBoard />} />
                        <Route path=':jobOfferSlug/' element={<JobOfferPage />} />
                    </Route>

                    <Route path="/profile/" element={subscriber_auth.isCompany || subscriber_auth.isApplicant ? <Profile /> : <Navigate to="/registration/" />}>
                        <Route index element={<ProfileMain />} />
                        
                        <Route path="curriculum-vitae/" element={subscriber_auth.isApplicant ? <CurriculumVitae /> : <Navigate to="/profile/" />} />
                        <Route path="bookmarked-offers/" element={subscriber_auth.isApplicant ? <BookmarkedOffers /> : <Navigate to="/profile/" />} />

                        <Route path="company-info/" element={subscriber_auth.isCompany ? <CompanyInfo /> : <Navigate to="/profile/" />} />
                        <Route path="job-offers/" element={subscriber_auth.isCompany ? <JobOffersList /> : <Navigate to="/profile/" />} />
                        <Route path="job-applications/" element={subscriber_auth.isCompany || subscriber_auth.isApplicant ? <JobApplicationsList /> : <Navigate to="/" />} />
                        <Route path="create-job-offer/" element={subscriber_auth.isCompany ? <CreateJobOffer /> : <Navigate to="/profile/" />} />
                        <Route path="edit-job-offer/:jobOfferSlug/" element={subscriber_auth.isCompany ? <EditJobOffer /> : <Navigate to="/profile/" />} />
                        <Route path="activities/" element={subscriber_auth.isCompany || subscriber_auth.isApplicant ? <ActivitiesList /> : <Navigate to="/" />} />
                        <Route path="settings/" element={subscriber_auth.isCompany || subscriber_auth.isApplicant ? <ProfileSettings /> : <Navigate to="/" />} />
                    </Route>

                    <Route path="/admin/" element={user && user.is('actajob') ? <Dashboard /> : <Navigate to="/" />}>
                        <Route index element={<Main />} />

                        <Route path="applicants/" element={<AdminApplicantsList />} />
                        <Route path="companies/" element={<AdminCompaniesList />} />
                        <Route path="job-offers/" element={<AdminJobOffersList />} />
                        <Route path="job-applications/" element={<AdminJobApplicationsList />} />
                        <Route path="activities/" element={<AdminActivitiesList />} />
                    </Route>
                </Routes>
            </Suspense>
        </BrowserRouter>
    </>;
}

export default AppRoutes;
